import type { ComponentProps } from 'react';

const InfoFilled = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM10.75 14.5H11.5V12.5H10.75C10.3344 12.5 10 12.1656 10 11.75C10 11.3344 10.3344 11 10.75 11H12.25C12.6656 11 13 11.3344 13 11.75V14.5H13.25C13.6656 14.5 14 14.8344 14 15.25C14 15.6656 13.6656 16 13.25 16H10.75C10.3344 16 10 15.6656 10 15.25C10 14.8344 10.3344 14.5 10.75 14.5ZM12 8C12.2652 8 12.5196 8.10536 12.7071 8.29289C12.8946 8.48043 13 8.73478 13 9C13 9.26522 12.8946 9.51957 12.7071 9.70711C12.5196 9.89464 12.2652 10 12 10C11.7348 10 11.4804 9.89464 11.2929 9.70711C11.1054 9.51957 11 9.26522 11 9C11 8.73478 11.1054 8.48043 11.2929 8.29289C11.4804 8.10536 11.7348 8 12 8Z"
        fill="#C5CCD6"
      />
    </svg>
  );
};

export default InfoFilled;
